import { Button, Form, Segment, Grid, Message } from 'semantic-ui-react'
import TextEditor from '../TextEditor'
import useStoreRelato from './store'
import { PropEditFormRelato } from './type'
import { Sigla } from '../Sigla'
import { ModalTextArea } from '../ModalTextArea'
import dayjs from 'dayjs'

export const EditFormRelato = (props: PropEditFormRelato) => {
  const {
    relato, onSucess, onError,
    canSave, canEnviar, canValidar, canSolicitarRevisao, canDevolver
  } = props
  const { store, api } = useStoreRelato(relato)

  const handleFunction = async (fn: Promise<string>, reload = true) => {
    try {
      const msg = await (fn)
      onSucess(msg, reload)
    } catch (error) {
      const detail = api.checkError('detail')
      if (detail) onError(detail)
    }
  }

  const save = async () => {
    await handleFunction(api.save(), false)
  }

  const saveSend = async () => {
    await handleFunction(api.enviar())
  }

  const saveValid = async () => {
    await handleFunction(api.validar())
  }

  const solicitarRevisao = async (motivoDevolucao?: string | number) => {
    await handleFunction(api.solicitarRevisao(motivoDevolucao))
  }

  const devolver = async (motivoDevolucao?: string | number) => {
    await handleFunction(api.devolver(motivoDevolucao))
  }

  enum Actions {
    enviar,
    validar,
    solicitarRevisao,
    devolver
  }

  const checkCanAction = (action: Actions) => {
    const situacao = store.alias_situacao || ''
    switch (action) {
      case Actions.enviar:
        return ['', 'em_elaboracao', 'aguardando_revisao'].includes(situacao)
      case Actions.validar:
      case Actions.solicitarRevisao:
        return ['aguardando_validacao'].includes(situacao)
      case Actions.devolver:
        return ['validado'].includes(situacao)
      default:
        return false
    }
  }

  return <Grid columns='equal' divided='vertically' className='edit-relato' key={store.id || store.key}>
    <Grid.Row stretched>
      <Grid.Column tablet={16} computer={14}>
        <Message
          attached
          header={store.id ? 'RELATO' : 'NOVO RELATO'}
        />
        <Form className='attached segment'>
          <Form.Group widths='equal'>
            <Form.Field width={1}>
              <label>Área</label>
              <Segment basic textAlign='center'>
                <Sigla
                  size={8}
                  requer_atencao={store.requer_atencao}
                >
                  {store.sigla_departamento}
                </Sigla>
              </Segment>
            </Form.Field>
            <Form.Field
              control={TextEditor}
              label='Descrição'
              name="txt-descricao"
              value={store.ultimos_andamentos}
              onChange={(e: string) => { api.setStore({ ultimos_andamentos: e }) }}
              error={api.checkError('ultimos_andamentos')}
              disabled={!canSave}
            />
            <Form.Field
              control={TextEditor}
              label='Necessidade de apoio'
              name="txt-necessidade-apoio"
              value={store.necessidade_apoio}
              onChange={(e: string) => { api.setStore({ necessidade_apoio: e }) }}
              error={api.checkError('necessidade_apoio')}
              disabled={!canSave}
            />
          </Form.Group>
          <Form.Group>
            <Form.Checkbox
              label='Requer atenção?'
              name="chk-requer-atencao"
              checked={store.requer_atencao}
              onChange={(e, d) => { api.setStore({ requer_atencao: d.checked }) }}
              disabled={!canSave}
            />
            {store.dsc_situacao && <Form.Field inline>
              <label>Situação:&nbsp;</label>
              {store.dsc_situacao}
            </Form.Field>}
            {relato?.relator && <Form.Field inline>
                <label>Relator:&nbsp;</label>
                {store?.relator}
              </Form.Field>}
            {relato?.validado_em && <>
              <Form.Field inline>
                <label>Validado em:&nbsp;</label>
                {dayjs(relato?.validado_em).format('L')}
              </Form.Field>
              <Form.Field inline>
                <label>Validado por:&nbsp;</label>
                {relato?.validado_por}
              </Form.Field>
            </>}
          </Form.Group>
        </Form>
        <Message
          warning
          attached='bottom'
          hidden={!store.motivo_devolucao}
          icon='exclamation triangle'
          content={store.motivo_devolucao}
        />
      </Grid.Column>
      <Grid.Column tablet={16} computer={2} verticalAlign='middle' className='edit-relato-actions'>
        <Segment basic>
          {canEnviar && <Button
            key='bt-enviar'
            floated='right'
            name="btn-salvarenviar-relato"
            onClick={saveSend}
            title='Salvar e enviar'
            disabled={api.checkLoading('enviar') || !checkCanAction(Actions.enviar)}
          >Salvar e enviar</Button>}
          {canValidar && <Button
            key='bt-validar'
            floated='right'
            name="btn-salvarvalidar-relato"
            onClick={saveValid}
            title='Salvar e validar'
            disabled={api.checkLoading('validar') || !checkCanAction(Actions.validar)}
          >Salvar e validar</Button>}
          {canSave && <Button
            key='bt-save'
            floated='right'
            name="btn-salvar-relato"
            onClick={save}
            title='Salvar relato'
            disabled={api.checkLoading('save')}
          >Salvar</Button>}
          {canSolicitarRevisao &&
            <ModalTextArea
              title='Motivo da devolução'
              onClick={v => solicitarRevisao(v)}
              trigger={
                <Button
                  key='bt-solicitar-revisao'
                  floated='right'
                  name="btn-devolver-relato"
                  title='Devolver relato'
                  disabled={api.checkLoading('solicitarRevisao') || !checkCanAction(Actions.solicitarRevisao)}
                >Devolver</Button>
              }
            />
          }
          {canDevolver &&
            <ModalTextArea
              title='Motivo da devolução'
              onClick={v => devolver(v)}
              trigger={
                <Button
                  key='bt-devolver'
                  floated='right'
                  name="btn-devolver-validacao-relato"
                  title='Devolver validação'
                  disabled={api.checkLoading('devolver') || !checkCanAction(Actions.devolver)}
                >Devolver validação</Button>
              }
            />
          }
        </Segment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
}
